import React, { useContext, useReducer} from 'react'

const AppContext = React.createContext();

const initialState = {
    login: sessionStorage.login,
    numeroFuncionario: sessionStorage.numeroFuncionario,
    tipoUsuario: sessionStorage.tipoUsuario,
    nombreFuncionario: sessionStorage.nombreFuncionario,
    lugar: sessionStorage.lugar,
    lugarCentral: sessionStorage.lugarCentral,
    numeroFuncionarioAsociado: sessionStorage.numeroFuncionarioAsociado,
    primeraVez: sessionStorage.primeraVez,
    escalafon: sessionStorage.escalafon,
    fotoPerfil: sessionStorage.fotoPerfil,
}

const useAppContext = () => {
    return useContext(AppContext);
}

const reducer = (state, action) => {
    console.log(action);
    return state;
}

const AppProvider = ({children}) => {
    const [state, dispatch] = useReducer(reducer, initialState);
    return (
        <AppContext.Provider value={{login: state.login, dispatch}}>
            {children}
        </AppContext.Provider>
    )
}

export {
    AppProvider, useAppContext
}